import loadergif from "../Assets/Images/GeoVase.png";
import Partner1 from "../Assets/Videos/PartnerVideo1Extended.mp4";
import Partner2 from "../Assets/Videos/PartnerVideo2.mp4";
import Partner3 from "../Assets/Videos/PartnerVideo3.mp4";
import PartnerCounter from "../Assets/Videos/Counter.mp4";

export const productStages = [
    {
        id: 1,
        src: loadergif,
        alt: "Initial product concept",
        description: "Blueprint to Brilliance",
        content:
            "Witness your product's transformation as it enters our innovation Pipeline.",

        type: "image",
    },
    {
        id: 2,
        src: Partner1,
        alt: "Product prototype",
        description: "Detailing for Distinction",
        content:
            "We generate important details like age, gender, and categories, and suitable events to your product, to help your product stand out, making it easier for people to find exactly what they’re looking for.",

        type: "video",
        scale: "scale-125",
    },
    {
        id: 3,
        src: Partner2,
        alt: "Product with basic features",
        description: "Fusing Feelings and Thoughts",
        content:
            "We infuse your product with empathic annotation to connect with a diverse range of users.",
        type: "video",
        scale: "scale-150",
    },
    {
        id: 4,
        src: Partner3,
        alt: "Product with advanced features",
        description: "Engaging in Endless Exploration",
        content:
            "Your product is ready to conquer new markets as it joins our dynamic portfolio.",
        type: "video",
    },
    {
        id: 5,
        src: PartnerCounter,
        alt: "Final product",
        description: "Building Better Business",
        content:
            "Prepare to see your product thrive with increased referrals and sales.",
        type: "video",
        scale: "scale-125",
    },
];
